<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="5"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -1"></div>
    <Submenu
      v-if="!Bignav"
      :Info="SubInfo"
      :DividNum="4"
      :BGImgUrl="'sbg0105.png'"
      :Submenu="Submenu"
      v-on:cellback="Navgo"
      style="z-index: -6"
    ></Submenu>
    <router-view />
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Submenu from "@/components/Submenu.vue";
export default {
  name: "Adaptive",
  data() {
    return {
      Bignav: false,
      SubInfo: {
        title: "適應性治療",
        body: ""
      },
      Submenu: [
        {
          id: "01",
          text: "何謂適應性治療"
        },
        {
          id: "02",
          text: "適應性療法的關鍵 <br>HyperSight"
        },
        {
          id: "03",
          text: "線上適應性放射治療 <br>Ethos智速刀"
        },
        {
          id: "04",
          text: "離線適應性放射治療<br>Halcyon Guidance"
        }
      ]
    };
  },
  components: {
    Back,
    Submenu,
    Bigmenu
  },
  methods: {
    Navgo(v) {
      switch (v) {
        case 0:
          this.$router.push("/AD01");
          break;
        case 1:
          this.$router.push("/AD02");
          break;
        case 2:
          this.$router.push("/T05");
          break;
        case 3:
          this.$router.push("/T06");
          break;
      }
    },
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;
}
</style>
